import {
	PageTitle,
	PageContainer,
	FloatBox,
	Heading,
	CmsContent,
	useHead,
} from '@mybonus/ui';

const title = 'Integritetspolicy';

export function PrivacyPolicyView() {
	useHead({ subtitle: title });

	return (
		<PageContainer width="narrow" noTopSpace>
			<PageTitle>
				<Heading level={1}>{title}</Heading>
			</PageTitle>

			<FloatBox>
				<CmsContent code="privacy_text" />
			</FloatBox>
		</PageContainer>
	);
}
